import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = { class: "navbar__wrapper container" }
const _hoisted_3 = {
  class: "navbar__text-wrapper",
  "data-float-text": ""
}
const _hoisted_4 = { class: "navbar__text" }

import BasicSvgIcon from '@/components/UI/BasicSvgIcon.vue';
import { HeaderLinks, defaultHeaderLinks } from '@/types/headerLinks';


export default /*#__PURE__*/_defineComponent({
  __name: 'TheNavBar',
  setup(__props) {

const headerLinks: HeaderLinks[] = defaultHeaderLinks;

let floatingText: HTMLElement;

const mouseOver = (e: Event) => {
  if (window.innerWidth >= 525) {
    const target = e.target as HTMLElement;
    floatingText = target.querySelector('[data-float-text]') as HTMLElement;
    floatingText.style.maxWidth = floatingText.scrollWidth + 'px';
  }
};

const mouseLeave = () => {
  if (window.innerWidth >= 525) {
    floatingText.style.maxWidth = '';
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BasicSvgIcon, {
        name: "logo-icon",
        width: "64",
        height: "64"
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(headerLinks), (link) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          key: link.key,
          to: link.url,
          class: _normalizeClass(["navbar__link", { 'navbar__link--profile' : link.url === '/profile' }]),
          "data-float-parent": "",
          onMouseover: _withModifiers(mouseOver, ["self"]),
          onMouseleave: mouseLeave
        }, {
          default: _withCtx(() => [
            _createVNode(BasicSvgIcon, {
              name: link.icon,
              width: "64",
              height: "64"
            }, null, 8, ["name"]),
            _createElementVNode("span", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(link.text), 1)
            ])
          ]),
          _: 2
        }, 1032, ["to", "class", "onMouseover"]))
      }), 128))
    ])
  ]))
}
}

})